@if (groupKey()) {
  <span>
    <nk-risk-level-icon [riskLevel]="groupKey()"></nk-risk-level-icon>
    {{ 'company_page.risk_model_grouping_' + groupKey() | translate }}
  </span>
}
